export default __webpack_public_path__ + "static/media/1.e3502796.jpg";